import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../hooks/useAuth';
import { useToast } from '../../../hooks/useToast';
import { getCurrentUser, uploadOwnPhoto } from '../../../services/auth.service';
import PhotoUpload from '../../../components/forms/PhotoUpload';
import Button from '../../../components/common/Button';
import { Camera } from 'lucide-react';

/**
 * Tela de bloqueio: o usuário administrativo só acessa o painel
 * após enviar sua foto de cadastro.
 */
const CompletePhoto = () => {
  const navigate = useNavigate();
  const { updateUser, logout } = useAuth();
  const toast = useToast();
  const [photoFile, setPhotoFile] = useState(null);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    setError('');

    if (!photoFile) {
      setError('A foto é obrigatória.');
      return;
    }

    setIsLoading(true);
    try {
      await uploadOwnPhoto(photoFile);
      // Rebusca o usuário atualizado (com photo_url) e persiste no contexto
      const fresh = await getCurrentUser();
      updateUser(fresh);
      toast.success('Foto enviada com sucesso!');
      navigate('/admin', { replace: true });
    } catch (err) {
      setError(err.message || 'Erro ao enviar foto.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="w-full max-w-md bg-white rounded-xl shadow-sm border border-gray-200 p-8 space-y-6">
        <div className="text-center">
          <div className="mx-auto h-12 w-12 bg-primary-100 rounded-full flex items-center justify-center">
            <Camera className="h-6 w-6 text-primary-600" />
          </div>
          <h1 className="mt-4 text-xl font-bold text-gray-900">Complete seu cadastro</h1>
          <p className="mt-1 text-sm text-gray-600">
            Para acessar o portal, é necessário enviar uma foto para o seu cadastro.
          </p>
        </div>

        <PhotoUpload value={photoFile} onChange={setPhotoFile} error={error} />

        <div className="flex flex-col gap-3">
          <Button type="button" variant="primary" loading={isLoading} onClick={handleSubmit}>
            Enviar foto e continuar
          </Button>
          <button
            type="button"
            onClick={logout}
            className="text-sm text-gray-500 hover:text-gray-700"
          >
            Sair
          </button>
        </div>
      </div>
    </div>
  );
};

export default CompletePhoto;
